const renewableTab = (() => {
  if (document.querySelector("body#pageRenewableenergy") !== null) {



    let sW = window.innerWidth;

    const secTabWraps = document.querySelectorAll('.js-sec-tab-wrap');



    // // タブ クラス
    // const tabTgl = (num) => {
    //   const secMenu = document.querySelector('#jsSecMenu');
    //   const secMenuBtm = document.querySelector('#jsSecMenuBtm');
    //   const menus = secMenu.querySelectorAll('.js-menu');
    //   const menusBtm = secMenuBtm.querySelectorAll('.js-menu');
    //   for (let i = 0; i < menus.length; i++) {
    //     menus[i].classList.remove('is-act');
    //     menusBtm[i].classList.remove('is-act');
    //   }
    //   menus[num].classList.add('is-act');
    //   menusBtm[num].classList.add('is-act');


    //   secTabWraps.forEach(element => {
    //     element.classList.remove('is-act');
    //     element.classList.remove('is-act2');
    //   });
    //   secTabWraps[num].classList.add('is-act');
    //   setTimeout(() => {
    //     secTabWraps[num].classList.add('is-act2');
    //   }, 100);
    // }
    // // タブ 初期非表示
    // tabTgl(0)



    // 事業内容 タブ
    if (document.querySelector("#jsSecOb") !== null) {
      const jsSecOb = document.querySelector('#jsSecOb');
      const tabWrap = jsSecOb.querySelector('.js-tab-wrap');
      const tabAreas = tabWrap.querySelectorAll('.js-tab-area');
      const bgBoxs = tabWrap.querySelectorAll('.js-bg-box');

      if (sW > 768) {

        tabAreas.forEach(element => {

          element.addEventListener('mouseover', () => {
            element.classList.add('is-act')

            bgBoxs.forEach(element2 => {
              element2.classList.add('is-act')
            });
          });

          element.addEventListener('mouseleave', () => {
            element.classList.remove('is-act')

            bgBoxs.forEach(element2 => {
              element2.classList.remove('is-act')
            });
          });
        });

      } else {

        let tl = gsap.timeline({
          scrollTrigger: {
            invalidateOnRefresh: true,
            trigger: '#jsSecOb .js-tab-wrap',
            start: "0% 40%",
            toggleClass: {
              targets: '#jsSecOb .js-tab-wrap',
              className: "is-act-sp"
            },
            once: true,
            // markers: true,
          },
        })
        let target = document.querySelector('body');
        let observer = new ResizeObserver((entries) => {
          entries.forEach((entry) => {
            tl.scrollTrigger.refresh()
          });
        });
        observer.observe(target);

      }

      tabAreas.forEach((element, index) => {
        element.addEventListener('click', () => {
          tabTgl(index + 1)
        });
      });
    }



    // // 共通 上下タブ
    // {
    //   const secMenu = document.querySelector('#jsSecMenu');
    //   const secMenuBtm = document.querySelector('#jsSecMenuBtm');
    //   const menus = secMenu.querySelectorAll('.js-menu');
    //   const menusBtm = secMenuBtm.querySelectorAll('.js-menu');

    //   menus.forEach((element, index) => {
    //     element.addEventListener('click', () => {
    //       tabTgl(index)
    //     });
    //   });
    //   menusBtm.forEach((element, index) => {
    //     element.addEventListener('click', () => {
    //       tabTgl(index)
    //     });
    //   });
    // }



    // 共通 中タブ
    {
      const reTabWraps = document.querySelectorAll('.js-re-tab-wrap');
      if (reTabWraps.length > 0) {

        reTabWraps.forEach(element => {
          const bgArea = element.querySelector('.js-bg-area');
          const reTabAreas = element.querySelectorAll('.js-re-tab-area');

          if (sW > 768) {

            reTabAreas.forEach((element2, index2) => {

              element2.addEventListener('mouseover', () => {
                bgArea.classList.add('is-act')
              });

              element2.addEventListener('mouseleave', () => {
                bgArea.classList.remove('is-act')
              });
            });

          }

          reTabAreas.forEach((element2, index2) => {

            element2.addEventListener('click', () => {
              tabTgl(index2 + 1)
            });
          });
        });
      }
    }



  }
})()
export default renewableTab;